// NPM Imports
import React from "react";
import { Tooltip } from "../../revvComponents";

// Internals Imports
import { truncateString } from "../../utils/globalUtils";

const RecipientDocTitle = ({ documentTitle }) => {
  const isMobileView = window.innerWidth <= 600;
  const docTitleLength = window.innerWidth <= 500 ? 20 : 35;
  return (
    <span className="recipientdoctitle-container">
      {isMobileView &&
      typeof documentTitle === "string" &&
      documentTitle.length >= docTitleLength ? (
        <Tooltip
          placement="bottom"
          align={{
            offset: [0, -4],
          }}
          overlay={documentTitle ? `${documentTitle}` : ""}>
          <span>{truncateString(documentTitle, docTitleLength, true)}</span>
        </Tooltip>
      ) : (
        documentTitle
      )}
    </span>
  );
};

export default RecipientDocTitle;
